import { mutation } from 'services/graphql';
import { gql } from '@apollo/client';

export const deleteInvitationOnSurfaceMutation = gql`
  mutation deleteUserInvitation($id: ID!) {
    deleteUserInvitation(id: $id) {
      error
      success
    }
  }
`;

export default mutation(deleteInvitationOnSurfaceMutation);
